export default {
  selectQrCors: { /** QR 과정정보를 조회 */
    method: 'GET',
    url: 'mrm/v1/ignore/attend/selectQrCors'
  },
  selectQrCorsBasic: { /** QR 과정 기본 정보를 조회 */
    method: 'GET',
    url: 'mrm/v1/ignore/attend/selectQrCorsBasic'
  },
  selectSendQrOtp: { /** QR OTP 생성 및 발송 */
    method: 'POST',
    url: 'mrm/v1/ignore/attend/otp/send'
  },
  selectCheckCertOtp: { /** OTP 인증, 정보 조회 */
    method: 'POST',
    url: 'mrm/v1/ignore/attend/otp/check'
  },
  updateCheckAtdnc: { /** 업데이트 출석 체크 */
    method: 'POST',
    url: 'mrm/v1/ignore/attend/atdnc/check'
  },
  selectAtdncInfo: { /** 출석 체크 정보 */
    method: 'GET',
    url: 'mrm/v1/ignore/attend/atdnc/info'
  },
  selectGreetingMessage: { /** 인사말 메시지 */
    method: 'GET',
    url: 'mrm/v1/ignore/attend/atdnc/greet'
  }
}



// WEBPACK FOOTER //
// ./src/config/router/nrw/api/attendApi.js